import {WinnerOfCompetition} from "./personal-achievements/WinnerOfCompetition";
import {ScientificProjectsConcurs} from "./personal-achievements/ScientificProjectsConcurs";
import {Hobbies} from "./personal-achievements/Hobbies";
import {OtherAchievements} from "./personal-achievements/OtherAchievements";
import {KnowledgeOfLanguages} from "./personal-achievements/KnowledgeOfLanguages";
import {CompetitionsPerformers} from "./personal-achievements/CompetitionsPerformers";

export class EnrollPersonalAchievements {
  winner_of_competition: WinnerOfCompetition = new WinnerOfCompetition();
  scientific_projects_concurs: ScientificProjectsConcurs = new ScientificProjectsConcurs();
  hobbies: Hobbies = new Hobbies();
  other_achievements: OtherAchievements = new OtherAchievements();
  knowledge_of_languages: KnowledgeOfLanguages = new KnowledgeOfLanguages();
  competitions_performers: CompetitionsPerformers = new CompetitionsPerformers();
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/model/enroll-personal-achievements.ts